export default {
  FACEBOOK: 'Facebook',
  GOOGLE: 'Google',
};
